import type { DialogFooterProps } from "./types-dialog-footer";
import { useDialogFooter } from "./use-dialog-footer";
import { DialogFooterView } from "./view-dialog-footer";

/** Cancelar e Confirmar do rodapé de um `Dialog`; o estado dos botões vem do `useDialogFooter`. */
export function DialogFooter(props: DialogFooterProps) {
  const viewModel = useDialogFooter(props);

  return <DialogFooterView {...viewModel} />;
}
DialogFooter.displayName = "DialogFooter";
